import { ActionBase } from '../../../core/store/action/ActionBase';

import { UndoDeleteConceptVersionModel } from "../../models/UndoDeleteConceptVersionModel";

export const UNDO_DELETE_CONCEPT_VERSION_SUCCESS = '[Vocabulary] Undo Delete Concept Version Success';

export class UndoDeleteConceptVersionSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = UNDO_DELETE_CONCEPT_VERSION_SUCCESS;

  constructor(public payload: { restoredConcept: UndoDeleteConceptVersionModel }) {}
}




// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/UndoDeleteConceptVersionSuccessAction.ts